import { useState, useEffect, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { GetSalesInboxResponse, SalesInboxConversation } from '@dreamai/types';
import api from '../../../api';
import { countNeedsAttention } from './salesInboxHelpers';

/**
 * Hook to fetch sales inbox conversations and provide the needs attention count
 * Used by the navigation to display the badge count
 */
export const useSalesInboxCount = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [conversations, setConversations] = useState<SalesInboxConversation[]>(
    [],
  );
  const [needsAttentionCount, setNeedsAttentionCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchConversations = useCallback(async () => {
    try {
      const token = await getAccessTokenSilently();
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      const response = await api.get<GetSalesInboxResponse>(
        '/sales-inbox/conversations',
        { params: { limit: 50 } },
      );

      if (response.data.success) {
        setConversations(response.data.conversations);
        setNeedsAttentionCount(
          countNeedsAttention(response.data.conversations),
        );
      }
    } catch (error) {
      console.error('Error fetching sales inbox conversations:', error);
    } finally {
      setLoading(false);
    }
  }, [getAccessTokenSilently]);

  useEffect(() => {
    fetchConversations();
  }, [fetchConversations]);

  return {
    conversations,
    needsAttentionCount,
    loading,
    refresh: fetchConversations,
  };
};
